import styled from "styled-components"
import { colors } from "../../lib/colors"

const redGradient = `linear-gradient(
  178.89deg,
  #db2e2e 14.22%,
  #e43030 36.3%,
  #f84444 99.05%
);`

const blueGradient = `linear-gradient(
  178.89deg,
  #1f3db6 14.22%,
  #2345ca 36.3%,
  #355aee 99.05%
);`

const greenGradient = `linear-gradient(
  178.89deg,
  #28a909 14.22%,
  #309b17 69.01%,
  #208707 99.05%
);`

export const Text = styled.p<{ margin?: string }>`
  text-transform: uppercase;
  margin: ${({ margin }) => (margin ? margin : 0)};
  font-weight: 300;
  &&.big {
    font-size: 18px;
  }
  &&.small {
    font-size: 14px;
  }
  &&.white {
    color: #c4c9dd;
  }
  &&.green {
    background: ${greenGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  &&.red {
    background: ${redGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  &&.blue {
    background: ${blueGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`
export const SubText = styled.span`
  &&.white {
    color: #c4c9dd;
    -webkit-text-fill-color: #c4c9dd;
  }
  &&.red {
    background: ${redGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  &&.green {
    background: ${greenGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  &&.blue {
    background: ${blueGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`

export const GameRulesConainer = styled.div`
  overflow-y: scroll;
  height: calc(100vh - 64px);
  ::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }

  @media (min-width: 767px) {
    max-height: 95%;
  }
`
export const Divider = styled.div<{ margin?: string }>`
  border: 1px solid rgba(255, 255, 255, 0.08);
  width: 100%;
  margin: ${({ margin }) => (margin ? margin : 0)};
`
export const BetBlockWrapper = styled.div`
  display: flex;
  /* gap: 10px; */
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 10px;
`

export const BetBlock = styled.div`
  background: rgba(11, 10, 13, 0.8);
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  min-width: 334px;
  max-width: 500px;
`
export const AutoPilot = styled.div<{ margin?: string }>`
  font-size: 14px;
  padding: 6px;
  width: 100%;
  text-align: center;
  color: #868b9e;
  background: rgba(22, 22, 28, 0.3);
  border-radius: 4px;
  border: 1px solid #272730;
  text-transform: uppercase;
  margin: ${({ margin }) => (margin ? margin : "0 0 14px")};
  &&.red {
    border: 1px solid rgba(223, 46, 46, 0.6);
    background: rgba(223, 46, 46, 0.4);
    color: #db2d2d;
  }
  @media only screen and (min-width: 768px) {
    font-size: 16px;
  }
  @media only screen and (min-width: 1024px) {
    font-size: 18px;
  }
`
export const BetAmountContainer = styled.div<{ margin?: string }>`
  display: flex;
  /* gap: 10px; */
  height: 52px;
  width: 100%;
  margin: ${({ margin }) => (margin ? margin : 0)};
  @media only screen and (min-width: 768px) {
    height: 72px;
    max-width: 500px;
  }
`
export const BetAmountWrapper = styled.div`
  display: flex;
  /* gap: 10px; */
  width: 50%;
`
export const BetAmount = styled.div`
  background: rgba(28, 30, 36, 0.6);
  box-shadow: inset 0px -2px 0px #292933;
  border-radius: 4px;
  padding: 8px 16px;
  width: 100%;

  p {
    color: #868b9e;
    font-size: 14px;
    text-transform: uppercase;
  }
  span {
    font-size: 24px;
    color: #ffffff;
  }
  @media only screen and (min-width: 768px) {
    p {
      font-size: 16px;
    }
    span {
      font-size: 26px;
    }
  }
  @media only screen and (min-width: 1024px) {
    p {
      font-size: 18px;
    }
    span {
      font-size: 34px;
    }
  }
`
export const Operations = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 10px;
`
export const Operation = styled.div<{ color?: string }>`
  background: ${({ color }) => (color ? blueGradient : redGradient)};
  box-shadow: inset 0px -1.56919px 0px ${({ color }) => (color ? "#1F3DB6" : "#F84444")};
  border-radius: 6px;
  font-size: 12px;
  width: 24px;
  height: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    font-size: 14px;
    width: 30px;
    height: 30px;
  }
  @media only screen and (min-width: 1024px) {
    font-size: 16px;
  }
`
export const BetButton = styled.div<{ color?: string }>`
  background: ${({ color }) =>
    color === "blue"
      ? blueGradient
      : color === "red"
      ? redGradient
      : greenGradient};
  box-shadow: inset 0px -3.02844px 0px ${({ color }) => (color === "blue" ? "#1F3DB6" : color === "red" ? "#F84444" : "#208707")};
  border-radius: 6px 4px;
  width: 50%;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  p {
    font-size: 18px;
  }
  span {
    font-size: 24px;
  }
  @media only screen and (min-width: 768px) {
    font-size: 26px;
    p {
      font-size: 22px;
    }
    span {
      font-size: 26px;
    }
  }
  @media only screen and (min-width: 1024px) {
    font-size: 34px;
    p {
      font-size: 24px;
    }
    span {
      font-size: 34px;
    }
  }
`
export const ImgBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin: 20px 0;
`
